import pageConfig from '@/baseData/enterpriseChildOrder/manageList'
import { operateMaxShowLength } from '@/store/dict/config'

export default function () {
  const { configData } = pageConfig.call(this, { dealWithData: this.dealWithData })
  const operateColumn = {
    name: 'operate',
    columnProps: {
      label: '操作',
      fixed: 'right',
    },
    maxShowLength: operateMaxShowLength,
    type: 'operate',
    getOperateList: ({ row }) => {
      const result = []
      result.push({ name: 'detail', label: '详情', action: () => this.toOrderDetailPage({ id: row.id }) })
      return result
    },
  }
  configData.tableData.columns.push(operateColumn)
  configData.isShowDepartment = false
  return { configData }
}
